module.exports = __webpack_public_path__ + "img/6.c4c77d6.png";